/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingQuoteReconfirmRequest
 */
export interface FlightBookingQuoteReconfirmRequest {
  /**
   *
   * @type {string}
   * @memberof FlightBookingQuoteReconfirmRequest
   */
  consentVersion: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingQuoteReconfirmRequest
   */
  consentDigest?: string;
}

/**
 * Check if a given object implements the FlightBookingQuoteReconfirmRequest interface.
 */
export function instanceOfFlightBookingQuoteReconfirmRequest(
  value: object
): value is FlightBookingQuoteReconfirmRequest {
  if (!("consentVersion" in value) || value["consentVersion"] === undefined)
    return false;
  return true;
}

export function FlightBookingQuoteReconfirmRequestFromJSON(
  json: any
): FlightBookingQuoteReconfirmRequest {
  return FlightBookingQuoteReconfirmRequestFromJSONTyped(json, false);
}

export function FlightBookingQuoteReconfirmRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingQuoteReconfirmRequest {
  if (json == null) {
    return json;
  }
  return {
    consentVersion: json["consent_version"],
    consentDigest:
      json["consent_digest"] == null ? undefined : json["consent_digest"],
  };
}

export function FlightBookingQuoteReconfirmRequestToJSON(
  json: any
): FlightBookingQuoteReconfirmRequest {
  return FlightBookingQuoteReconfirmRequestToJSONTyped(json, false);
}

export function FlightBookingQuoteReconfirmRequestToJSONTyped(
  value?: FlightBookingQuoteReconfirmRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    consent_version: value["consentVersion"],
    consent_digest: value["consentDigest"],
  };
}
